import { MapPin, ExternalLink } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHeader, Reveal } from "@/components/bits";
import { OFFICES, mapsUrl } from "@/data/site";

const Presence = () => (
  <>
    <Seo
      title="Our Presence | Ambrotech Private Limited"
      description="Ambrotech Private Limited offices in Delhi, Patna, and Silvassa — corporate office, sales office, and industrial presence."
      path="/presence"
    />

    <PageHeader
      eyebrow="Our Presence"
      title="Offices in Delhi, Patna, and Silvassa"
      lead="Three locations covering our corporate, sales, and industrial operations."
    />

    <section className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
      <div className="grid gap-6 lg:grid-cols-3" data-testid="presence-grid">
        {OFFICES.map((o, i) => (
          <Reveal key={o.city} delay={i * 0.08} className="h-full">
            <div className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(11,25,44,0.09)]" data-testid={`office-card-${o.city.toLowerCase()}`}>
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-navy text-brand">
                  <MapPin className="h-5 w-5" />
                </span>
                <span className="rounded-full bg-brand/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.12em] text-brand">
                  {o.tag}
                </span>
              </div>
              <h2 className="mt-6 font-display text-xl font-bold text-navy">{o.label}</h2>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{o.address}</p>
              <a
                href={mapsUrl(o.address)}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-navy transition-colors hover:text-brand"
                data-testid={`office-map-link-${o.city.toLowerCase()}`}
              >
                View on Google Maps
                <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <p className="mt-12 text-center text-sm text-slate-500">
          For product availability and enquiries in your region, please reach us through the{" "}
          <a href="tel:+919229204554" className="font-semibold text-navy underline decoration-brand decoration-2 underline-offset-4 transition-colors hover:text-brand" data-testid="presence-sales-phone-link">
            Sales Enquiry number
          </a>{" "}
          or the{" "}
          <a href="mailto:official.ambrotech@gmail.com" className="font-semibold text-navy underline decoration-brand decoration-2 underline-offset-4 transition-colors hover:text-brand" data-testid="presence-email-link">
            official email
          </a>
          .
        </p>
      </Reveal>
    </section>
  </>
);

export default Presence;